const about = {
	banner: [{
		tips:'平台简介',
		title:'联系方式',
		content:'',
		img: require('@/assets/img/index/GPI_2x.png'),
		url: require('@/assets/img/index/banner01.png'),		
	}],	
	adress:'联系地址：北京市',
	call:'客服热线：0871-43255632',
	email:'邮箱地址：epd_cnia@sina.com'
}

export default about